// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__46jdR","footer":"ChangeClinic_footer__3d7ob"};